import { NodeIds, InputIds } from '.';
import { ContractComparisonPanel } from '../types';

const ContractComparisonPanels: Record<string, ContractComparisonPanel[]> = {
    [NodeIds.GeneralInformation]: [
        {
            id: 'ContractStructure',
            name: 'Contract Structure',
            inputIds: [
                InputIds.GeneralInformation.Title,
                InputIds.GeneralInformation.CreateProgram,
                InputIds.GeneralInformation.BusinessType,
                InputIds.GeneralInformation.TypeOfParticipation,
                InputIds.GeneralInformation.Lifecycle,
                InputIds.GeneralInformation.Currency,
                InputIds.GeneralInformation.ReportUnits
            ]
        },
        {
            id: 'Period',
            name: 'Period',
            inputIds: [
                InputIds.GeneralInformation.UnderwritingYear,
                InputIds.GeneralInformation.PeriodStart,
                InputIds.GeneralInformation.PeriodEnd
            ]
        },
        {
            id: 'CoverageClassification',
            name: 'Coverage Classification',
            inputIds: [
                InputIds.GeneralInformation.MainClass,
                InputIds.GeneralInformation.Class,
                InputIds.GeneralInformation.SubClass,
                InputIds.GeneralInformation.CountryGroups,
                InputIds.GeneralInformation.Countries
            ]
        },
        {
            id: 'Partners',
            name: 'Partners',
            inputIds: [
                InputIds.GeneralInformation.Cedent,
                InputIds.GeneralInformation.Broker,
                InputIds.GeneralInformation.Insured,
                InputIds.GeneralInformation.Reinsurer
            ]
        }
    ]
};

export default ContractComparisonPanels;
